(() => {
  if (!window.customElements || customElements.get('printique-related-carousel')) return;
  customElements.define('printique-related-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const update = () => {
        const rail = this.querySelector('.pq-recs__rail');
        if (!rail) return;
        const prev = this.querySelector('[data-direction="-1"]');
        const next = this.querySelector('[data-direction="1"]');
        if (prev) prev.disabled = rail.scrollLeft < 2;
        if (next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button || !this.contains(button)) return;
        const rail = this.querySelector('.pq-recs__rail');
        rail?.scrollBy({left: Number(button.dataset.direction) * rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal});
      this.addEventListener('scroll', update, {capture: true, passive: true, signal});
      this.resize = new ResizeObserver(update);this.resize.observe(this);
      this.mutations = new MutationObserver(update);this.mutations.observe(this, {childList: true, subtree: true});
      update();
    }
    disconnectedCallback() { this.controller?.abort();this.controller = null;this.resize?.disconnect();this.mutations?.disconnect(); }
  });
})();
